import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { API_URL, USER } from 'src/api';
import { handleErrorToast, handleSuccessToast } from 'src/components/molecules';

export function useRemoveMultipleUsersMutation() {
  const queryClient = useQueryClient();

  const { mutate: removeMultiple } = useMutation({
    mutationFn: (ids: string[]) => {
      return Promise.all(
        ids.map((id) => axios.delete(`${API_URL}${USER(id)}`)),
      );
    },
    onSuccess: () => {
      handleSuccessToast({ toastMessage: 'Users removed successfully' });
      queryClient.invalidateQueries('SearchUsersPaginated');
    },
    onError: (err: {
      response: { data: { errors: { message: string }[] } };
    }) => {
      const error = err?.response?.data?.errors[0]?.message
        ? err.response.data.errors[0].message
        : `Can't remove users`;
      handleErrorToast({ toastMessage: `${error}` });
    },
  });

  return removeMultiple;
}
